import React from 'react'

import { Portlet, Row, Col, Button, Form } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as SaldosInicialesCrud from 'services/saldosIniciales.service'
import * as JobService from 'services/job.service'

import { ZrSwal } from 'utils'

const ObtenerSaldosAnoPasado = () => {
  const __zariContext = React.useContext(ZariContext)

  const [calculando, setCalculando] = React.useState(false)
  const [flagPaseSoloPositivo, setFlagPaseSoloPositivo] = React.useState(false)

  const iniciarJobSaldos = React.useCallback(() => {
    JobService.iniciarJob('SALDOS_ANO_PASADO', { flagPaseSoloPositivo })
      .then(() => {
        __zariContext.snack('info', 'Obtener saldos año pasado iniciado. Se notificará cuando termine.')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => setCalculando(false))
  }, [__zariContext, flagPaseSoloPositivo])

  const clickObtener = React.useCallback(() => {
    setCalculando(true)
    SaldosInicialesCrud.validarExistenciaSaldosIniciales().then(({ data }) => {
      if (data.length > 0) {
        ZrSwal.showAlert({
          tipo: 'warning',
          mensaje: '¿Deseas eliminar los saldos iniciales de todas las sedes?',
          showCerrar: true,
          onSuccess: () => {
            for (let i = 0; i < data.length; i++) {
              SaldosInicialesCrud.eliminarSaldoInicial(data[i])
            }
            iniciarJobSaldos()
          },
          onClose: () => {
            setCalculando(false)
          }
        })
      } else {
        iniciarJobSaldos()
      }
    })
  }, [__zariContext, iniciarJobSaldos])

  return (
    <Portlet>
      <Portlet.Header title='Obtener saldos año pasado' />
      <Portlet.Body>
        <Row>
          <Col md={6}>
            <Form.Checkbox
              checked={flagPaseSoloPositivo}
              id='checkbox-flagPaseSoloPositivo'
              name='checkbox-flagPaseSoloPositivo'
              label='Usar costo de reposición'
              onChange={() => setFlagPaseSoloPositivo(prev => !prev)}
            />
          </Col>
          <Col md={6} className='text-right'>
            <Button disabled={calculando} onClick={clickObtener}>
              Obtener saldos año pasado
            </Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ObtenerSaldosAnoPasado)
